<template>
  <b-modal
    :id="id"
    hide-footer
    :modal-class="isV2 ? 'modal-v2-wrapper' : 'success-popup'"
    hide-header
  >
    <div
      v-if="isV2"
      class="modal-v2-content"
    >
      <!-- Icon -->
      <div class="modal-v2-icon info">
        <svg
          width="64"
          height="64"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle
            cx="12"
            cy="12"
            r="10"
          />
          <line
            x1="12"
            y1="16"
            x2="12"
            y2="12"
          />
          <line
            x1="12"
            y1="8"
            x2="12.01"
            y2="8"
          />
        </svg>
      </div>
      <!-- Title -->
      <h2 class="modal-v2-title">
        <slot name="title" />
      </h2>
      <!-- Message -->
      <p class="modal-v2-message">
        <slot name="info">
          {{ $t('modal-info.try-again') }}
        </slot>
      </p>
    </div>
    <!-- Footer outside content to span full width -->
    <div
      v-if="isV2"
      class="modal-v2-footer"
    >
      <b-button
        class="btn btn-outline-secondary"
        @click="$bvModal.hide(id)"
      >
        Close
      </b-button>
    </div>
    <div
      v-else
      class="text-center modal-complete"
    >
      <svg class="icon icon-icon-popup-wrong">
        <use xlink:href="#icon-icon-popup-wrong--circle" />
      </svg>
      <h2 style="margin: 0;">
        <slot name="title" />
      </h2>
      <div class="popup-meta">
        <slot name="info">
          {{ $t('modal-info.try-again') }}
        </slot>
      </div>
      <div class="d-flex justify-content-center align-items-center">
        <b-button
          variant="outline-primary"
          class="w-100 m-3"
          @click="$bvModal.hide(id)"
        >
          Close
        </b-button>
      </div>
    </div>
  </b-modal>
</template>
<script>
  export default {
    props: {
      id: {
        default: 'info-modal',
        type: String
      },
      v2: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      isV2() {
        // Auto-detect if in Kiosk V2 or use v2 prop
        return this.v2 || this.$route?.name?.includes('V2') || false;
      }
    }
  }
</script>
